"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EBuilderAnimation_1 = require("./EBuilderAnimation");

var EBuilderError_1 = require("./EBuilderError");

var Check = require("../utils/Check");

var DOM = require("../utils/DOM");

var Parse = require("../utils/Parse");

var Setter = require("../utils/Setter");

var EBuilder = function EBuilder(source) {
  if (!Check.isValidSource(source)) {
    new EBuilderError_1["default"]('Invalid source input', source);
    return;
  }

  var element = Setter.element(source);
  var referenceMap = new Map([['window', window]]);
  var cloneList = [];
  return {
    get el() {
      return element;
    },

    get element() {
      return element;
    },

    get htmlContent() {
      return this.element.innerHTML;
    },

    get count() {
      return this.element.childNodes.length;
    },

    get children() {
      return this.element.childNodes;
    },

    isEBuilder: true,
    referenceMap: referenceMap,
    cloneList: cloneList,
    getRef: function getRef(query) {
      return query ? this.referenceMap.get(query) : (new EBuilderError_1["default"]('nul!', query), false);
    },
    given: function given() {
      var _this = this;

      var register = function register(ref) {
        if (Check.isArray(ref)) {
          var _ref = (0, _slicedToArray2["default"])(ref, 2),
              target = _ref[0],
              id = _ref[1]; // come back here later


          _this.referenceMap.set(id, target);
        } else if (Check.isNamedFunction(ref)) {
          _this.referenceMap.set(ref.name, ref);
        } else new EBuilderError_1["default"]('Invalid given() argument input', ref);
      };

      for (var _len = arguments.length, references = new Array(_len), _key = 0; _key < _len; _key++) {
        references[_key] = arguments[_key];
      }

      references.forEach(register);
      return this;
    },
    into: function into(targetInput) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$at = _ref2.at,
          at = _ref2$at === void 0 ? -1 : _ref2$at,
          _ref2$times = _ref2.times,
          times = _ref2$times === void 0 ? 1 : _ref2$times;

      if (!Check.isValidTarget(targetInput) || !Check.isNumber(times)) return; // use Parse.getTrueElement() instead

      var getTarget = function getTarget(target) {
        return Check.isEBObject(target) ? target.element : target;
      };

      DOM.insertV1.call(this, this.element, getTarget(targetInput), at, times);
      this.element.dispatchEvent(new CustomEvent('ebuilderinsert'));
      return this;
    },
    after: function after(inputTarget) {
      var target = Parse.getTrueElement(inputTarget);
      target.insertAdjacentElement('afterend', element);
      this.element.dispatchEvent(new CustomEvent('ebuilderinsert'));
      return this;
    },
    before: function before(inputTarget) {
      var target = Parse.getTrueElement(inputTarget);
      target.insertAdjacentElement('beforebegin', element);
      this.element.dispatchEvent(new CustomEvent('ebuilderinsert'));
      return this;
    },
    replace: function replace(inputTarget) {
      var _a;

      var target = Parse.getTrueElement(inputTarget);
      (_a = target.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(element, target);
      this.element.dispatchEvent(new CustomEvent('ebuilderinsert'));
      return this;
    },
    swap: function () {
      var _swap = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(swapped, animate) {
        var ms, dummy;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (Check.isValidSwap(element, swapped)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!animate) {
                  _context.next = 6;
                  break;
                }

                ms = (0, _typeof2["default"])(animate) === 'object' && animate.animationDuration ? animate.animationDuration : undefined;
                _context.next = 6;
                return new EBuilderAnimation_1["default"](ms).swap2(element, swapped);

              case 6:
                dummy = document.createElement('div');
                element.parentNode.replaceChild(dummy, element);
                swapped.parentNode.replaceChild(element, swapped);
                dummy.parentNode.replaceChild(swapped, dummy);
                return _context.abrupt("return", this);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function swap(_x, _x2) {
        return _swap.apply(this, arguments);
      }

      return swap;
    }(),
    out: function out(all) {
      var _a;

      (_a = element.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(element);
      if (all) this.clearClones;
      return this;
    },
    clearClones: function clearClones() {
      this.cloneList.forEach(function (clone) {
        var _a;

        return (_a = clone.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(clone);
      });
      return this;
    },
    dispatch: function dispatch(nameInput, emitterInput) {
      var emitter = !emitterInput ? this.element : 'isEBuilder' in emitterInput ? emitterInput.element : emitterInput;
      emitter.dispatchEvent(new CustomEvent(nameInput));
      return this;
    },
    set: function set() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var Options = {
        properties: Setter.Properties,
        attributes: Setter.Attributes,
        listeners: Setter.Listeners,
        children: Setter.Children,
        style: Setter.Style
      };

      var setOption = function setOption(name, value) {
        if (!(name in Options)) return;
        Options[name].call(_this2, value);
      };

      Setter.process.call(this, options, setOption);
      this.element.dispatchEvent(new CustomEvent('ebuilderset'));
      return this;
    },
    setAttributes: function setAttributes(attributes) {
      Setter.Attributes.call(this, attributes);
      return this;
    },
    setProperties: function setProperties(properties) {
      Setter.Properties.call(this, properties);
      return this;
    },
    setListeners: function setListeners(listeners) {
      Setter.Listeners.call(this, listeners);
      return this;
    },
    setChildren: function setChildren(children) {
      Setter.Children.call(this, children);
      return this;
    },
    setStyle: function setStyle(style) {
      Setter.Style.call(this, style);
      return this;
    },
    setClasses: function setClasses() {
      var _element$classList, _ref3;

      (_element$classList = element.classList).add.apply(_element$classList, (0, _toConsumableArray2["default"])((_ref3 = []).concat.apply(_ref3, arguments)));

      return this;
    },
    // + setContent(options = { add?, remove?,  })
    setContent: function setContent(input) {
      var value = Parse.getComputedValue.call(this, input);
      this.element.innerHTML = "".concat(value); // DOM.insert.call(this, input, element, at, 1)

      return this;
    },
    toString: function toString() {
      return element.outerHTML;
    }
  };
};

exports["default"] = EBuilder;